/**
 * Slack Approval Status Widget
 * 
 * Shows the number of pending Slack approvals and links to the queue.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useSlackStatus } from '../hooks/useSlackStatus';
import { Badge } from '@/components/ui/badge';
import { MessageSquare, ExternalLink } from 'lucide-react';

export function SlackApprovalStatus({ brandId }) {
  const { status, loading, error } = useSlackStatus(brandId);
  
  // Don't render if not connected or loading
  if (loading || !status?.connected) return null;
  
  const pending = status.pending_approvals || 0;
  const channelName = status.default_channel?.name;
  
  return (
    <Link 
      to="/dashboard/approvals"
      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
      data-testid="slack-approval-status"
    >
      <MessageSquare className="h-4 w-4 text-primary" />
      <span className="text-sm text-muted-foreground">Slack Approvals:</span>
      <Badge 
        variant={pending > 0 ? "default" : "secondary"}
        className={pending > 0 ? "bg-amber-500/20 text-amber-300 border-amber-500/30" : ""}
      >
        {pending} pending
      </Badge>
      {channelName && (
        <span className="text-xs text-muted-foreground hidden md:inline">
          #{channelName}
        </span>
      )}
      <ExternalLink className="h-3 w-3 text-muted-foreground" />
    </Link>
  );
}

export default SlackApprovalStatus;
